module.exports = __webpack_public_path__ + "img/jgouwuche.9a91dd97.gif";